// import React from "react";
import * as React from "react";

import { FaCheck, FaGift } from "react-icons/fa";
import { IoCloseSharp } from "react-icons/io5";
import { TiTick } from "react-icons/ti";

function SilverPackage() {
  const [showMore, setShowMore] = React.useState(false);
  const handleShowMore = () => {
    setShowMore(!showMore);
  };
  return (
    <div className="">
      <div className="flex justify-between ">
        {/* Silver */}
        <div className="flex flex-col  space-y-5 py-10 px-16 bg-gray-100 rounded-lg shadow-md">
          <div className="flex items-center gap-3">
            <div className="bg-red-100 p-4 rounded-lg">
              <FaGift className="text-3xl text-primary " />
            </div>
            <p className="text-2xl font-semibold">Silver</p>
          </div>
          <div className="flex flex-col  gap-3">
            <div className="flex gap-3 items-center">
              <div>
                <h1 className="text-6xl font-semibold">$99</h1>
              </div>
              <p>/monthly</p>
            </div>
            <h2 className="text-2xl font-bold">What's Included</h2>
          </div>
          <div className="flex flex-col gap-3">
            <div className="flex gap-4 items-center ">
              <div className="flex items-center justify-center w-6 h-6 bg-green-500 rounded-full text-white text-xs font-semibold">
                <FaCheck />
              </div>
              <p className="text-gray-800  text-lg"> Listings (3)</p>
            </div>
            <div className="flex gap-4 items-center ">
              <div className="flex items-center justify-center w-6 h-6 bg-green-500 rounded-full text-white text-xs font-semibold">
                <FaCheck />
              </div>
              <p className="text-gray-800  text-lg"> Listings (3)</p>
            </div>
            <div className="flex gap-4 items-center ">
              <div className="flex items-center justify-center w-6 h-6 bg-green-500 rounded-full text-white text-xs font-semibold">
                <FaCheck />
              </div>
              <p className="text-gray-800  text-lg"> Images Per Listings (3)</p>
            </div>
            <div className="flex gap-4 items-center ">
              <div className="flex items-center justify-center w-6 h-6 bg-red-500 rounded-full text-white text-lg font-semibold">
                <IoCloseSharp />
              </div>
              <p className="text-gray-800  text-lg"> Enquiry Form</p>
            </div>
            <div className="flex gap-4 items-center ">
              <div className="flex items-center justify-center w-6 h-6 bg-red-500 rounded-full text-white text-lg font-semibold">
                <IoCloseSharp />
              </div>
              <p className="text-gray-800  text-lg"> Video</p>
            </div>
            <div className="flex gap-4 items-center ">
              <div className="flex items-center justify-center w-6 h-6 bg-green-500 rounded-full text-white text-xs font-semibold">
                <FaCheck />
              </div>
              <p className="text-gray-800  text-lg">
                {" "}
                Amenities Per Listing (3)
              </p>
            </div>
            <div className="flex gap-4 items-center ">
              <div className="flex items-center justify-center w-6 h-6 bg-green-500 rounded-full text-white text-xs font-semibold">
                <FaCheck />
              </div>
              <p className="text-gray-800  text-lg">
                {" "}
                Features Per Listing (3)
              </p>
            </div>
            {showMore ? (
              <div>
                <div className="flex gap-4 items-center ">
                  <div className="flex items-center justify-center w-6 h-6 bg-green-500 rounded-full text-white text-xs font-semibold">
                    <FaCheck />
                  </div>
                  <p className="text-gray-800  text-lg">
                    {" "}
                    Social Links Per Listing (3)
                  </p>
                </div>
                <div className="flex gap-4 items-center ">
                  <div className="flex items-center justify-center w-6 h-6 bg-green-500 rounded-full text-white text-xs font-semibold">
                    <FaCheck />
                  </div>
                  <p className="text-gray-800  text-lg">
                    {" "}
                    FAQs Per Listing (3)
                  </p>
                </div>
              </div>
            ) : (
              " "
            )}
            <div>
              <button
                onClick={handleShowMore}
                className="text-black font-semibold"
              >
                {showMore ? "Show Less" : "Show More"}
              </button>
            </div>
            <div>
              <button
                // onClick={handleDropdownCustomer}
                className="bg-white text-primary text-lg mt-6 font-semibold px-8 py-3 border border-[#F8735F]  rounded-lg"
              >
                Purchase
              </button>
            </div>
          </div>
        </div>
        {/* Gold */}

        {/* Platinum */}
      </div>
    </div>
  );
}

export default SilverPackage;
